export default `<p style="margin-bottom:0;text-align:center;line-height:150%">
    <strong><span style="font-size:24px;line-height:150%; ">责任免除</span></strong>
</p>
<p style="margin-bottom:0;line-height:150%">
    <strong><span style="font-size:14px;line-height: 150%; ">本保险适用的主要责任免除如下，其他责任免除条款以与美亚财产保险有限公司正式订立保险合同的规定为准。</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">1.</span></strong><strong><span style="font-size:14px; ">美亚团体意外伤害保险（2021年第一版）（互联网专属）（注册编号：C00003932312021121719483）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">任何在下列期间发生的或由下列原因造成的被保险人的伤害，或出现下列任一情形时，本公司不负任何赔偿责任：</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(1)</span><span style="font-size:14px; ">战争、军事行动、暴乱、罢工、武装叛乱或任何形式的恐怖活动。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(2)</span><span style="font-size:14px; ">任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤或辐射。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(3)</span><span style="font-size:14px; ">投保人的故意行为；或被保险人无论当时神志是否清醒，自致伤害或自杀。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(4)</span><span style="font-size:14px; ">因被保险人故意行为（见义勇为行为除外）而导致的打斗、被袭击或被谋杀。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(5)</span><span style="font-size:14px; ">被保险人因从事违法犯罪的活动或因拒捕而导致的伤害；以及因遭受司法当局拘禁或被判入狱期间。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(6)</span><span style="font-size:14px; ">被保险人因酗酒或受酒精、毒品、管制药物的影响而导致的意外。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(7)</span><span style="font-size:14px; ">被保险人因精神错乱或失常而导致的意外。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(8)</span><span style="font-size:14px; ">被保险人酒后驾车、无照驾驶或驾驶无有效行驶证的机动交通工具。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(9)</span><span style="font-size:14px; ">被保险人罹患艾滋病（AIDS）或感染艾滋病病毒（HIV）期间（上述定义，应按世界卫生组织所订的定义为准。若在被保险人的血液样本中发现上述病毒或其抗体，则认定已受该病毒感染）。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(10)</span><span style="font-size:14px; ">被保险人置身于任何飞机或空中运输工具（以乘客身份搭乘民用或商业航班者除外）期间。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(11)</span><span style="font-size:14px; ">先天性畸形。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(12)</span><span style="font-size:14px; ">受保前已存在的受伤及其并发症。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(13)</span><span style="font-size:14px; ">被保险人进行赛马、潜水、滑水、滑雪、滑翔翼、跳伞、攀岩运动、摔跤、柔道、空手道、跆拳道、马术、武术、拳击的运动或特技表演。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(14)</span><span style="font-size:14px; ">被保险人参与任何职业或半职业的体育运动。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(15)</span><span style="font-size:14px; ">被保险人进行各种车辆表演、车辆竞赛或练习、驾驶卡丁车。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(16)</span><span style="font-size:14px; ">被保险人于海军、空军、陆军服军役或以警察身份执行任务期间。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(17)</span><span style="font-size:14px; ">被保险人从事采矿业、地下作业、山洞作业、水上作业、五米以上高处作业的职业活动期间。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(18)</span><span style="font-size:14px; ">妊娠、流产、分娩及由此引起的伤害；性传播疾病引起的伤害；美容手术、外科整形手术或其他医疗导致的伤害。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(19)</span><span style="font-size:14px; ">细菌或病毒感染（但因意外伤害致有伤口而发生感染者除外）、食物中毒。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">&nbsp;</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">2.</span></strong><strong><span style="font-size:14px; ">美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）（注册编号：C00003932522021122436913）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">主合同中所有责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。任何在下列期间发生的或由下列原因导致的医药费用，本公司不负赔偿责任：</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（1）任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（2）屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（3）一般的身体检查（不包括因意外事故进行的牙科和眼科检查）、疗养、特别护理或静养、康复性治疗或心理治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（4）脊椎病。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（5）中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（6）任何在中医科、理疗科、康复科进行的治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（7）任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（8）任何过敏反应、药物过敏或其他医疗导致的伤害。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（9）未取得医生的证明。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（10）中国大陆境内医院自主制定价格并在特定区域内提供的特需医疗服务，包括但不限于特需门诊、特需病区、国际医疗、干部病房的相关医疗服务。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">（11）中国大陆境内当地社会基本医疗保险管理部门规定全额自费的诊疗项目和药品、检查、治疗、材料等费用，但在境外医院发生的医药费用除外。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">&nbsp;</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">3.</span></strong><strong><span style="font-size:14px; ">美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）（注册编号：C00003931922021072908971）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">主合同中责任免除条款均适用于本附加合同，若主合同中责任免除条款与本条款有相抵触之处，则应以本条款为准。任何在下列期间发生的，或由下列原因直接、间接地造成被保险人入住医院，或出现下列任一情形时，本公司不负任何赔偿责任：</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(1)</span><span style="font-size:14px; ">任何原因进行的牙齿保养、牙齿修复、牙齿整形或牙齿植种；非因意外事故进行的任何牙科检查、治疗或手术，以及任何进食活动（包括咀嚼或啃咬）引发的牙科治疗；对非自然牙进行的任何治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(2)</span><span style="font-size:14px; ">屈光不正；任何非因意外事故而进行的眼科检查、视力矫正，以及因矫正视力而作的眼科验光检查。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(3)</span><span style="font-size:14px; ">一般的身体检查（不包括因意外事故进行的牙科和眼科检查）、疗养、特别护理或静养、康复性治疗或心理治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(4)</span><span style="font-size:14px; ">脊椎病。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(5)</span><span style="font-size:14px; ">中草药、中药材或任何传统中医治疗，传统中医治疗包括但不限于推拿、按摩、指压治疗、足科治疗、营养师治疗、理疗、针法、灸法、针灸、顺势治疗、整骨治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(6)</span><span style="font-size:14px; ">任何在中医科、理疗科、康复科进行的治疗。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(7)</span><span style="font-size:14px; ">任何妊娠、流产、分娩、不孕不育症、避孕或绝育手术、美容手术、外科整形手术。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(8)</span><span style="font-size:14px; ">任何过敏反应、药物过敏或其他医疗导致的伤害。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">(9)</span><span style="font-size:14px; ">未取得医生的证明。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">&nbsp;</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">4.</span></strong><strong><span style="font-size:14px; ">美亚附加特种作业限制条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437203）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方理解并同意，被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方进一步理解并同意，特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">&nbsp;</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">5.</span></strong><strong><span style="font-size:14px; ">美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437123）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方理解并同意，本合同承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本条款所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。为明确起见，特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方进一步理解并同意，任何在下列期间发生的意外事故，或出现下列任一情形时，本公司不承担任何保险责任：（1）被保险人从事高处作业时未系绑安全带。（2）被保险人在从事距坠落高度基准面5米及以上高处作业时未取得对应的特种作业证书。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">&nbsp;</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">6.</span></strong><strong><span style="font-size:14px; ">美亚附加不承保特定医院条款（2021年第二版）（注册编号：C00003931922021072908951）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方理解并同意，本合同所称的医院不包括：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">&nbsp;</span>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <strong><span style="font-size:14px; ">7.</span></strong><strong><span style="font-size:14px; ">美亚附加经济制裁责任免除条款（注册编号：C00003931922019052907382）</span></strong>
</p>
<p style="margin-bottom:0;text-indent:28px;line-height:normal">
    <span style="font-size:14px; ">兹经双方理解并同意，若本公司/保险人在本保险合同项下提供任何保险保障、利益或支付任何保险赔偿金会导致本公司/保险人违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规，则本公司/保险人在本保险合同项下不提供前述保险保障、利益，亦不支付前述保</span><span style=" ">险赔偿金。</span>
</p>
<p style="margin-bottom:0;text-indent:29px;line-height:normal">
    <span style=" ">&nbsp;</span>
</p>
<p style="text-indent:28px">
    <strong><span style="font-size:14px; color:windowtext">8.</span></strong><strong><span style="font-size:14px; ;color:windowtext">美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）（注册编号：C00003932322021122437063）</span></strong>
</p>
<p style="text-indent:28px">
    <span style="font-size:14px; color:windowtext">兹经双方理解并同意，本合同仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。</span>
</p>
<p style="text-indent:28px">
    <span style="font-size:14px; color:windowtext">兹经双方进一步理解并同意，本合同所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。</span>
</p>
`
